/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import Api from '../../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import IOutput from './models/output';

export const getExamRankingList = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.QUIZ_RANKING_LIST, data).then((res: IListResponse<IOutput>) => {
        return res.data as IList<IOutput>;
    });
};

export const getNewExamRankingList = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.NEW_QUIZ_RANKING_LIST, data).then((res: IListResponse<IOutput>) => {
        return res.data as IList<IOutput>;
    });
};
